import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetCustomerTypeReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today
    sort_by: 'total_shipping/-1',
  }

  const {filters, onDateChange, onSortingChange} = useFilters(initialFilters, {sortType: 'number'})

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/shipping-report/customer-types',
    {
      queryId: 'shipping-customer-type-report',
      filters,
      isToast: false,
      isErrorPageRedirection: false,
    }
  )

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSortingChange,
    handleCustomerTypeReportDateChange: onDateChange,
    pagination: response?.meta?.pagination || {},
  }
}

export default useGetCustomerTypeReport
